<div *ngIf="showDownloadStatus" style="background-color: #1E6BA1; color: white; width: 100%;margin-top: 1em;border-radius: 4px 4px 0px 0px; font-weight: bold; padding-left: .7em;">Data Cart Status</div>
<div *ngFor="let key of getKeys; let i=index" style="width: 100%;border: 1px solid rgb(231, 231, 231); border-radius: 0px 0px 4px 4px;">
    <span *ngIf="dataCartStatus.dataCartStatusItems[key].downloadPercentage > 0" style="display:inline-block;padding: 0.5em; width: 100%;">
        <span style="font-size:smaller ;font-weight: 300; color:black">{{cartName(key)}}</span>
        <div style="width: 100%;">
            <span style="display:inline-block;width: calc(100% - 20px);">
                <ngb-progressbar type="info" [value]="dataCartStatus.dataCartStatusItems[key].downloadPercentage" textType="white" [showValue]="true"
                    [striped]="true"></ngb-progressbar>
            </span>
            <span (click)="removeStatusItem(key)" style="float: right;cursor: pointer;padding-left:5px;" data-toggle="tooltip" title="Cancel all downloads"><i class="faa faa-remove"></i></span>
        </div>
    </span>
</div>
